import { render, staticRenderFns } from "./Empresa-tab-atendimento.vue?vue&type=template&id=71cf07ee&scoped=true&"
import script from "./Empresa-tab-atendimento.vue?vue&type=script&lang=js&"
export * from "./Empresa-tab-atendimento.vue?vue&type=script&lang=js&"
import style0 from "./Empresa-tab-atendimento.vue?vue&type=style&index=0&id=71cf07ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf07ee",
  null
  
)

export default component.exports